import React from 'react';
import { SvgIcon } from '@mui/material';
const SvgPress = (props) => (
  <SvgIcon {...props} title="Press">
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M46.286 15.429v22.285a4.286 4.286 0 0 1-8.571 0v-30A1.714 1.714 0 0 0 36 6H3.429a1.714 1.714 0 0 0-1.714 1.714v30.857A3.429 3.429 0 0 0 5.143 42h36.858"
        stroke="#017163"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.429 14.57H12v8.572h15.429V14.57ZM12 33.43h15.429"
        stroke="#017163"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </SvgIcon>
);
export default SvgPress;
